import React from "react";
import { Input } from '@material-ui/core';
import { Paper } from "@material-ui/core";
import * as S from '../formStyle';

function IntegerBox({
    title,
    filterName,
    handleInputChange,
    valoresRespostas,
    isLoading,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth
}) {
  const classes = S.useStyles();

  return (
    <>
        <label className={classes.label}>{title}</label>
        <Paper className={classes.medium} style={{ width: `${componenteWidth}px` }} elevation={0}>
            <Input
                className={classes.input}
                type='text'
                value={valoresRespostas[ordem]}
                inputProps={{style: { textAlign: 'end', paddingRight: '15px' }}}
                name={filterName}
                disabled={isLoading || disabledList[ordem]}
                onChange={(e) => {
                    if (e.target.value !== '') {
                        if (/^[0-9\b]+$/.test(e.target.value)) {
                            handleInputChange(e, ordem, e.target.value, conteudoOnChange)
                        }
                    } else {
                        handleInputChange(e, ordem, e.target.value, conteudoOnChange)
                    }
                }}
            />
        </Paper>
    </>
    
  );
}

export default IntegerBox;
